import { deployPathPrefix } from './deployPaths'

export function siteExpiredPath(): string {
  const prefix = deployPathPrefix()
  if (prefix.length === 0) return '/expired'
  return `${prefix}/expired`.replace(/\/+/g, '/')
}
